import React, { Component } from 'react';
import Slider from "react-slick";

import Golfwithsliderhotel from '../components/golfwithhotelslider.js';
import Testimonialslider from '../components/testimonialslider.js';

import { Container, Row, Col, Tabs, Tab, Button, Form } from 'react-bootstrap';

import { FaChevronLeft, FaChevronRight, FaMapMarkerAlt, FaPercent, FaRegClock, FaStar, FaStarHalfAlt, FaPhoneAlt, FaEnvelope, FaUserAlt, FaPencilAlt, FaRegCalendarAlt } from "react-icons/fa";

// import { BiSupport, BiLike } from "react-icons/bi";



import slideimg from '../assets/images/slider-1.png';
import destimage from '../assets/images/destication.png';

import featureimg from '../assets/images/featured.png';


import high1 from '../assets/images/sale.png';
import high2 from '../assets/images/24-hr.png';
import high3 from '../assets/images/clock.png';
import high4 from '../assets/images/like.png';








// import TabContent from 'react-bootstrap/TabContent';



export default class PreviousNextMethods extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
    }
    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }
    render() {
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: 3000,
            arrows: false,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]

        };







        return (
            <div className="main">

                <div className="home-slider">
                    <Slider ref={c => (this.slider = c)} {...settings}>
                        <div >
                            <div className="images-caption" >
                                <img src={slideimg} className=" img-fluid" alt="language" />

                                <div className="overlay-text text-center text-white">
                                    <h1 className="heading text-uppercase">Banyan Golf Hua Hin</h1>
                                    <h6 className="sub-heading text-uppercase"><FaMapMarkerAlt />Thailand</h6>

                                    <ul className="action-btn">
                                        <li><a href="#" className="book-btn">Book now</a></li>
                                        <li><a href="#" className="learn-btn">Learn More</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>


                        <div >
                            <div className="images-caption" >
                                <img src={slideimg} className=" img-fluid" alt="language" />

                                <div className="overlay-text text-center text-white">
                                    <h1 className="heading text-uppercase">Banyan Golf Hua Hin</h1>
                                    <h6 className="sub-heading text-uppercase"><FaMapMarkerAlt />Thailand</h6>

                                    <ul className="action-btn">
                                        <li><a href="#" className="book-btn">Book now</a></li>
                                        <li><a href="#" className="learn-btn">Learn More</a></li>
                                    </ul>
                                </div>

                            </div>
                        </div>



                    </Slider>

                    <ul className="slidebtn">
                        <li><button className="home-prev" onClick={this.previous} ><FaChevronLeft /></button></li>
                        <li><button className="home-next" onClick={this.next}><FaChevronRight /></button></li>
                    </ul>




                </div>

                <section className="filter-category">
                    <Container className="container-new">

                        <div className="mcustom-filter">
                            <Tabs defaultActiveKey="home" id="uncontrolled-tab-example">
                                <Tab eventKey="home" title="Golf Only " className="golf-icon">
                                    <div className="green-box">

                                        <Row>
                                            <Col md={6} lg={3}>
                                                <Form.Group>

                                                    <Form.Control type="text" placeholder="WHERE" className="location-icon" />

                                                    <span className="custom-icon"><FaMapMarkerAlt /></span>
                                                </Form.Group>

                                            </Col>


                                            <Col md={6} lg={3}>
                                                <Form.Group>

                                                    <Form.Control type="text" placeholder="WHEN" className="location-date" />

                                                    <span className="custom-icon"><FaRegCalendarAlt /></span>

                                                </Form.Group>
                                            </Col>

                                            <Col md={6} lg={3}>
                                                <Form.Group>


                                                    <Form.Control type="text" placeholder="HOW LONG" className="location-time" />
                                                    <span className="custom-icon"><FaRegClock /></span>
                                                </Form.Group>
                                            </Col>


                                            <Col md={6} lg={3}>
                                                <Button className="search">search now</Button>
                                            </Col>
                                        </Row>
                                    </div>

                                </Tab>
                                <Tab eventKey="profile" title="Golf + Hotel" className="hotel-icon">
                                    <div className="green-box">

                                        <Row>
                                            <Col md={6} lg={3}>
                                                <Form.Group>

                                                    <Form.Control type="text" placeholder="WHERE" />
                                                </Form.Group>

                                            </Col>


                                            <Col md={6} lg={3}>
                                                <Form.Group>

                                                    <Form.Control type="text" placeholder="WHEN" className="date-icon" />

                                                </Form.Group>
                                            </Col>

                                            <Col md={6} lg={3}>
                                                <Form.Group>

                                                    <Form.Control type="time" placeholder="HOW LONG" />
                                                </Form.Group>
                                            </Col>


                                            <Col md={6} lg={3}>
                                                <Button className="search">search now</Button>
                                            </Col>
                                        </Row>
                                    </div>

                                </Tab>

                            </Tabs>
                        </div>


                    </Container>

                    <Container>

                        <div className="highlight-box pb-5 pt-5">
                            <Row>
                                <Col lg={3} md={6} xs={6} >
                                    <h3 className="hight-light-text text-uppercase ">

                                        <span className="green-color">
                                            <img src={high1} className="img-fluid" alt="best price" />

                                        </span>

                                          &nbsp;&nbsp;best price
                                    </h3>



                                </Col>



                                <Col lg={3} md={6} xs={6} >
                                    <h3 className="hight-light-text text-uppercase">

                                        <span className="green-color">
                                            <img src={high2} className="img-fluid" alt="best price" /> </span>
                                           &nbsp;&nbsp;24/7 support
                                    </h3>



                                </Col>


                                <Col lg={3} md={6} xs={6} >
                                    <h3 className="hight-light-text text-uppercase ">

                                        <span className="green-color">
                                            <img src={high3} className="img-fluid" alt="best price" /> </span>  &nbsp;&nbsp;save time
                                    </h3>



                                </Col>

                                <Col lg={3} md={6} xs={6} >
                                    <h3 className="hight-light-text text-uppercase ">

                                        <span className="green-color">
                                            <img src={high4} className="img-fluid" alt="best price" /> </span>  &nbsp;&nbsp;100% recommended
                                    </h3>



                                </Col>

                            </Row>
                        </div>


                    </Container>

                </section>


                {/* popular golfcourse */}

                <section className="popular-golf commanPaddding">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h2 className="site-title text-uppercase ">
                                    <strong>   Popular </strong>golf destinations
                                </h2>
                            </Col>

                            <Col md={12}>
                                <ul className="popular-dest">
                                    <li>
                                        <span className="featured-badge">
                                            <img src={featureimg} className="img-fluid" />
                                        </span>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>


                                    <li>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>

                                    <li>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>

                                    <li>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>

                                    <li>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>

                                    <li>
                                        <img src={destimage} className="img-fluid" />

                                        <div className="product-inquiry">
                                            <h3>Hua Hin</h3>
                                            <p><FaMapMarkerAlt /> &nbsp;&nbsp;Thailand</p>

                                            <div className="review-box">
                                                <ul className="star">
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStar /></li>
                                                    <li><FaStarHalfAlt /></li>
                                                </ul>

                                                <a href="#" className="booknow">
                                                    Book now
                                        </a>

                                            </div>

                                        </div>
                                    </li>
                                </ul>


                                <a href="#" className="load-more btn-orange">load more destinations</a>

                            </Col>

                        </Row>
                    </Container>
                </section>

                <Golfwithsliderhotel />

                <section className="any-question text-white">
                    <Container>
                        <Row>
                            <Col md={4}>
                                <h2 className="quest">Any questions?</h2>
                            </Col>

                            <Col md={6}>
                                <p>Visit our FAQ's and clarify all your doubts.
                                If your question is not answered, please
feel free to send us a message.</p>

                            </Col>


                            <Col md={2}>
                                <a href="#" className="btn btn-orange full-width-btn mt-0 text-white">FAQ</a>

                            </Col>



                        </Row>
                    </Container>
                </section>


                <section className="testimonial commanPaddding">
                    <Container>
                        <Row>
                            <Col md={12}>
                                <h2 className="site-title text-uppercase ">
                                    <strong>   testimonials </strong>
                                </h2>
                            </Col>

                            <Col md={12}>
                                <Testimonialslider />
                            </Col>

                        </Row>
                    </Container>
                </section>



            </div>

        )
    }
}
